import {
  getAllMessages,
  getMessage,
  sendMessage as sendMessageApiCall,
} from "~/lib/network/chat";
import { GamgeeChatMessageRead, RichMessageContent } from "~/types/message";
interface ChatMessagesState {
  chatMessages: GamgeeChatMessageRead[];
  messageInputDraft: string;
  fetchChatMessages: (sessionId: string) => Promise<void>;
  markStreamingFinished: (messageId: string, finalMessage: string) => void;
  markRichStreamingFinished: (messageId: string) => void;
  markAssetStreamingFinished: (messageId: string) => void;
  addMessage: (message: GamgeeChatMessageRead) => void;
  sendMessage: (sessionId: string, message: string) => Promise<void>;
  setMessageInputDraft: (text: string) => void;
  clearChatMessages: () => void;
  reset: () => void;
}

const defaultState: ChatMessagesState = {
  chatMessages: [],
  messageInputDraft: "",
  fetchChatMessages: async () => {},
  markStreamingFinished: () => {},
  markRichStreamingFinished: async () => {},
  markAssetStreamingFinished: async () => {},
  addMessage: () => {},
  sendMessage: async () => {},
  setMessageInputDraft: () => {},
  clearChatMessages: () => {},
  reset: () => {},
};

export const createSessionMessagesSlice = (
  set: any,
  get: any,
  storeApi: any
) => {
  return {
    ...defaultState,
    fetchChatMessages: async (sessionId: string) => {
      const allMessages = await getAllMessages(sessionId);
      set((state: ChatMessagesState) => ({ chatMessages: allMessages }));
    },
    markStreamingFinished: (messageId: string, finalMessage: string) => {
      set((state: ChatMessagesState) => {
        return {
          chatMessages: state.chatMessages.map((message) =>
            message._id === messageId
              ? {
                  ...message,
                  message: {
                    ...message.message,
                    content: finalMessage,
                    message_type: "text",
                  },
                }
              : { ...message }
          ),
        };
      });
    },
    markRichStreamingFinished: async (messageId: string) => {
      const updatedMessage = await getMessage(messageId);
      set((state: ChatMessagesState) => ({
        chatMessages: state.chatMessages.map((message) =>
          message._id === messageId ? updatedMessage : { ...message }
        ),
      }));
    },
    markAssetStreamingFinished: async (messageId: string) => {
      const updatedMessage = await getMessage(messageId);
      set((state: ChatMessagesState) => ({
        chatMessages: state.chatMessages.map((message) =>
          message._id === messageId ? updatedMessage : { ...message }
        ),
      }));
    },
    addMessage: (message: GamgeeChatMessageRead) => {
      set((state: ChatMessagesState) => ({
        chatMessages: [...state.chatMessages, message],
      }));
    },
    sendMessage: async (
      sessionId: string,
      message: string,
      attachments?: File[]
    ) => {
      const [sentMessage, responseMessage] = await sendMessageApiCall(
        sessionId,
        message,
        attachments
      );
      set((state: ChatMessagesState) => ({
        chatMessages: [...state.chatMessages, sentMessage, responseMessage],
      }));
    },
    setMessageInputDraft: (text: string) =>
      set((state: ChatMessagesState) => ({ messageInputDraft: text })),
    clearChatMessages: () =>
      set((state: ChatMessagesState) => ({ chatMessages: [] })),
    reset: () => set(defaultState),
  };
};
